import styles from "./Contacts.module.css"
import Navbar from "../../components/Navbar/NavbarMain/Navbar";
import Footer from "../../components/Footer/Footer";
import nemjovaSrc from "../../assets/images/characters/nemjova.png"
import nejezchlebSrc from "../../assets/images/characters/nejezchleb.png"
import bobkovaSrc from "../../assets/images/characters/bobkova.png"
import poberezskySrc from "../../assets/images/characters/poberezsky.png"
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { useCmsContent } from "../../hooks/useCmsContent";
import { pickCmsText, renderHighlight } from "../../utils/cmsText";
/**
* Contact page.
* Contains info about the companys main team members and contacts.
* The team characters and the contact details block are editable in the CMS;
* while a field/list is empty the built-in characters and texts are shown.
* @returns TSX.Element
*/
const Contacts = () => {
    const { t, i18n } = useTranslation(); // Translation
    const cms = useCmsContent();
    const page = cms?.contactsPage;

    // Built-in team, used whenever the CMS team list is empty
    const fallbackTeam = [
        { image: nejezchlebSrc, label: `Lukáš Nejezchleb, ${t("contacts.team.executive")}`, email: "lukas@catermat.com" },
        { image: bobkovaSrc, label: `Veronika Bobková, ${t("contacts.team.store")}`, email: "veronika@catermat.com" },
        { image: poberezskySrc, label: `Dan Poběrežský, ${t("contacts.team.logistics")}`, email: "dan@catermat.com" },
        { image: nemjovaSrc, label: `Mária Nemjová, ${t("contacts.team.product_manager")}`, email: "marika@catermat.com" },
    ];

    // Any published CMS member replaces the whole built-in team
    const cmsTeam = page?.team ?? [];
    const members =
        cmsTeam.length > 0
            ? cmsTeam.map((m) => {
                  const name = m.name ?? "";
                  const role = pickCmsText(m.role, i18n.language, "");
                  return {
                      key: m._key,
                      image: m.imageUrl ?? "",
                      label: role ? `${name}, ${role}` : name,
                      email: m.email ?? "",
                  };
              })
            : fallbackTeam.map((m, index) => ({ key: `builtin-${index}`, ...m }));

    // Contact details block: each field falls back to the built-in translation.
    // The built-in texts use <4/> as a line break, converted to a newline for renderHighlight.
    const info = page?.contactInfo;
    const brToNl = (value: string) => value.replace(/<4\s*\/?>/g, "\n");
    const phones = pickCmsText(
        info?.phones,
        i18n.language,
        `${t("contacts.details.phones.1")}\n${t("contacts.details.phones.2")}`
    );
    const billingTitle = pickCmsText(info?.billingTitle, i18n.language, t("contacts.details.billing.title"));
    const billingText = pickCmsText(info?.billingText, i18n.language, brToNl(t("contacts.details.billing.text")));
    const bankingTitle = pickCmsText(info?.bankingTitle, i18n.language, t("contacts.details.banking.title"));
    const bankingText = pickCmsText(info?.bankingText, i18n.language, brToNl(t("contacts.details.banking.text")));

    return(
        <>
        <div className={styles.Page}>
            <div className={styles.Header}>
                <div className={styles.Headergroup}>
                    <Navbar/>
                </div>
            </div>
                <div className={styles.Content}>
                    <div className={styles.CatermatTeam}>
                        <p className={styles.CatermatTeamTitle}><Trans i18nKey="contacts.team.title" components={{ 1: <span/> }} /></p>
                        <div className={styles.CatermatTeamCharacters}>
                            {members.map((member) => (
                                <div className={styles.Character} key={member.key}>
                                    <div className={styles.CharacterImage} style={{backgroundImage: `url(${member.image})`}}></div>
                                    <div className={styles.CharacterTitle}>
                                        <p>{member.label}</p>
                                        <span>{member.email}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles.ContactInfo}>
                        <p className={styles.ContactInfoTitle}><Trans i18nKey="contacts.details.title" components={{ 1: <span/> }} /></p>
                        <div className={styles.ContactInfoContent}>
                            <p>
                                {renderHighlight(phones)}<br/><br/>
                                <span>{billingTitle}</span><br/>
                                {renderHighlight(billingText)}<br/><br/>
                                <span>{bankingTitle}</span><br/>
                                {renderHighlight(bankingText)}<br/>
                            </p>
                        </div>
                    </div>
            </div>
            <div className={styles.Footer}>
                <Footer/>
            </div>
        </div>
        </>
    )
};

export default Contacts;
